import { TabTypeBooking } from '../pages/patientBooking'
import { ERouteGroupColor, ERouteName, IRoute } from './IRoute'
import {
  ACCOUNT_MANAGEMENT_PATHS,
  EXAM_MANAGEMENT_PATHS,
  HELP_PATHS,
  MENUS_MANAGEMENT_PATHS,
  PATIENT_MANAGEMENT_PATHS,
  REPO_MANAGEMENT_PATHS,
  ROLE_MANAGEMENT_PATHS
} from './menuRoutes'
import { TIME_DELAY_FALLBACK } from 'constants/common'
import AccountRolePage from 'pages/roles'
import { lazy } from 'react'

const ClinicInfoPage = lazy(async () => {
  const [moduleExports] = await Promise.all([
    import('./../pages/accountClinicInfo'),
    new Promise((resolve) => setTimeout(resolve, TIME_DELAY_FALLBACK))
  ])
  return moduleExports
})
const BookingPage = lazy(async () => {
  const [moduleExports] = await Promise.all([
    import('../pages/patientBooking'),
    new Promise((resolve) => setTimeout(resolve, TIME_DELAY_FALLBACK))
  ])
  return moduleExports
})
const PatientDetailPage = lazy(async () => {
  const [moduleExports] = await Promise.all([
    import('../pages/patientBooking/components/patientDetail'),
    new Promise((resolve) => setTimeout(resolve, TIME_DELAY_FALLBACK))
  ])
  return moduleExports
})

const DashboardPage = lazy(async () => {
  const [moduleExports] = await Promise.all([
    import('../pages/patientDashboard'),
    new Promise((resolve) => setTimeout(resolve, TIME_DELAY_FALLBACK))
  ])
  return moduleExports
})
const ReceivePage = lazy(async () => {
  const [moduleExports] = await Promise.all([
    import('../pages/patientReceive'),
    new Promise((resolve) => setTimeout(resolve, TIME_DELAY_FALLBACK))
  ])
  return moduleExports
})
const PaymentPage = lazy(async () => {
  const [moduleExports] = await Promise.all([
    import('../pages/patientPayment'),
    new Promise((resolve) => setTimeout(resolve, TIME_DELAY_FALLBACK))
  ])
  return moduleExports
})
const TransactionPage = lazy(async () => {
  const [moduleExports] = await Promise.all([
    import('../pages/patientTransaction'),
    new Promise((resolve) => setTimeout(resolve, TIME_DELAY_FALLBACK))
  ])
  return moduleExports
})
const PrescriptionPage = lazy(async () => {
  const [moduleExports] = await Promise.all([
    import('../pages/patientPrescription'),
    new Promise((resolve) => setTimeout(resolve, TIME_DELAY_FALLBACK))
  ])
  return moduleExports
})
const GroupServicePage = lazy(async () => {
  const [moduleExports] = await Promise.all([
    import('../pages/menuGroupService'),
    new Promise((resolve) => setTimeout(resolve, TIME_DELAY_FALLBACK))
  ])
  return moduleExports
})
const SubServicePage = lazy(async () => {
  const [moduleExports] = await Promise.all([
    import('../pages/menuSubServices'),
    new Promise((resolve) => setTimeout(resolve, TIME_DELAY_FALLBACK))
  ])
  return moduleExports
})
const WorkingSchedulePage = lazy(async () => {
  const [moduleExports] = await Promise.all([
    import('../pages/menuWorkingSchedule'),
    new Promise((resolve) => setTimeout(resolve, TIME_DELAY_FALLBACK))
  ])
  return moduleExports
})
const DoctorPage = lazy(async () => {
  const [moduleExports] = await Promise.all([
    import('../pages/menuDoctor'),
    new Promise((resolve) => setTimeout(resolve, TIME_DELAY_FALLBACK))
  ])
  return moduleExports
})
const TemplatePage = lazy(async () => {
  const [moduleExports] = await Promise.all([
    import('../pages/menuTemplate'),
    new Promise((resolve) => setTimeout(resolve, TIME_DELAY_FALLBACK))
  ])
  return moduleExports
})
const ClinicRoomPage = lazy(async () => {
  const [moduleExports] = await Promise.all([
    import('../pages/menuClinicRoom'),
    new Promise((resolve) => setTimeout(resolve, TIME_DELAY_FALLBACK))
  ])
  return moduleExports
})
const ExamPage = lazy(async () => {
  const [moduleExports] = await Promise.all([
    import('../pages/exam'),
    new Promise((resolve) => setTimeout(resolve, TIME_DELAY_FALLBACK))
  ])
  return moduleExports
})
const SubclinicalPage = lazy(async () => {
  const [moduleExports] = await Promise.all([
    import('../pages/examSubclinical'),
    new Promise((resolve) => setTimeout(resolve, TIME_DELAY_FALLBACK))
  ])
  return moduleExports
})
const SupersonicPage = lazy(async () => {
  const [moduleExports] = await Promise.all([
    import('../pages/examSupersonic'),
    new Promise((resolve) => setTimeout(resolve, TIME_DELAY_FALLBACK))
  ])
  return moduleExports
})
const RepoInventoryPage = lazy(async () => {
  const [moduleExports] = await Promise.all([
    import('../pages/repoInventory'),
    new Promise((resolve) => setTimeout(resolve, TIME_DELAY_FALLBACK))
  ])
  return moduleExports
})
const RepoExportPage = lazy(async () => {
  const [moduleExports] = await Promise.all([
    import('../pages/repoExport'),
    new Promise((resolve) => setTimeout(resolve, TIME_DELAY_FALLBACK))
  ])
  return moduleExports
})
const RepoImportPage = lazy(async () => {
  const [moduleExports] = await Promise.all([
    import('../pages/repoImport'),
    new Promise((resolve) => setTimeout(resolve, TIME_DELAY_FALLBACK))
  ])
  return moduleExports
})
const AccountUserPage = lazy(async () => {
  const [moduleExports] = await Promise.all([
    import('../pages/accountUser'),
    new Promise((resolve) => setTimeout(resolve, TIME_DELAY_FALLBACK))
  ])
  return moduleExports
})
const UserManual = lazy(async () => {
  const [moduleExports] = await Promise.all([
    import('../pages/helpUserManual'),
    new Promise((resolve) => setTimeout(resolve, TIME_DELAY_FALLBACK))
  ])
  return moduleExports
})
const Contact = lazy(async () => {
  const [moduleExports] = await Promise.all([
    import('../pages/helpContact'),
    new Promise((resolve) => setTimeout(resolve, TIME_DELAY_FALLBACK))
  ])
  return moduleExports
})
const SystemSetting = lazy(async () => {
  const [moduleExports] = await Promise.all([
    import('../pages/accountSystemSetting'),
    new Promise((resolve) => setTimeout(resolve, TIME_DELAY_FALLBACK))
  ])
  return moduleExports
})

export const ROUTES_ACCOUNTS_MANAGEMENT: Array<IRoute> = [
  {
    path: ACCOUNT_MANAGEMENT_PATHS.clinicInfo,
    rootPath: ACCOUNT_MANAGEMENT_PATHS.main,
    component: <ClinicInfoPage />,
    icon: '/images/ic-clinic-info.svg',
    name: ERouteName.AccountManagement_ClinicInfo
  },
  {
    path: ACCOUNT_MANAGEMENT_PATHS.user,
    rootPath: ACCOUNT_MANAGEMENT_PATHS.main,
    component: <AccountUserPage />,
    icon: '/images/ic-group-user.svg',
    name: ERouteName.AccountManagement_User
  },
  {
    path: ROLE_MANAGEMENT_PATHS.user,
    rootPath: ACCOUNT_MANAGEMENT_PATHS.main,
    component: <AccountRolePage />,
    icon: '/images/ic-role-manage.svg',
    name: ERouteName.AccountManagement_Role
  },
  {
    path: ACCOUNT_MANAGEMENT_PATHS.systemSetting,
    rootPath: ACCOUNT_MANAGEMENT_PATHS.main,
    icon: '/images/ic-system-setting.svg',
    name: ERouteName.AccountManagement_SystemSetting,
    children: [
      {
        path: '/',
        rootPath: '',
        component: <SystemSetting />,
        icon: '/images/ic-receive.svg',
        name: ERouteName.AccountManagement_SystemSettingAdd
      },
      {
        path: ACCOUNT_MANAGEMENT_PATHS.systemSettingDetail,
        rootPath: '',
        component: <SystemSetting />,
        icon: '/images/ic-receive.svg',
        name: ERouteName.AccountManagement_SystemSettingDetail
      }
    ]
  }
]

export const ROUTERS_MANAGEMENT_PATIENT: Array<IRoute> = [
  {
    path: PATIENT_MANAGEMENT_PATHS.dashboard,
    rootPath: PATIENT_MANAGEMENT_PATHS.main,
    component: <DashboardPage />,
    icon: '/images/ic-dashboard.svg',
    name: ERouteName.PatientManagement_Dashboard
  },
  {
    path: PATIENT_MANAGEMENT_PATHS.booking,
    rootPath: PATIENT_MANAGEMENT_PATHS.main,
    icon: '/images/ic-booking.svg',
    name: ERouteName.PatientManagement_Booking,
    children: [
      {
        path: '/',
        rootPath: '',
        component: <BookingPage tab={TabTypeBooking.Booking} />,
        icon: '/images/ic-booking.svg',
        name: ERouteName.PatientManagement_Booking
      },
      {
        path: PATIENT_MANAGEMENT_PATHS.patientDetail,
        rootPath: '',
        component: <PatientDetailPage />,
        icon: '/images/ic-booking.svg',
        name: ERouteName.PatientManagement_PatientDetail
      }
    ]
  },
  {
    path: PATIENT_MANAGEMENT_PATHS.patient,
    rootPath: PATIENT_MANAGEMENT_PATHS.main,
    icon: '/images/ic-doctor.svg',
    name: ERouteName.PatientManagement_Patient,
    children: [
      {
        path: '/',
        rootPath: '',
        component: <BookingPage tab={TabTypeBooking.Patient} />,
        icon: '/images/ic-booking.svg',
        name: ERouteName.PatientManagement_Patient
      },
      {
        path: PATIENT_MANAGEMENT_PATHS.patientDetail,
        rootPath: '',
        component: <PatientDetailPage />,
        icon: '/images/ic-booking.svg',
        name: ERouteName.PatientManagement_PatientDetail
      }
    ]
  },
  {
    path: PATIENT_MANAGEMENT_PATHS.receive,
    rootPath: PATIENT_MANAGEMENT_PATHS.main,
    icon: '/images/ic-receive.svg',
    name: ERouteName.PatientManagement_Receive,
    hideOnMainPage: true,
    hideOnSidebar: true,
    children: [
      {
        path: '/',
        rootPath: '',
        component: <ReceivePage />,
        icon: '/images/ic-receive.svg',
        name: ERouteName.PatientManagement_ReceiveAdd
      },
      {
        path: '/:id',
        rootPath: '',
        component: <ReceivePage />,
        icon: '/images/ic-receive.svg',
        name: ERouteName.PatientManagement_ReceiveDetail
      }
    ]
  },
  {
    path: PATIENT_MANAGEMENT_PATHS.payment,
    rootPath: PATIENT_MANAGEMENT_PATHS.main,
    icon: '/images/ic-dollar.svg',
    name: ERouteName.PatientManagement_Payment,
    children: [
      {
        path: '/',
        rootPath: '',
        component: <PaymentPage />,
        icon: '/images/ic-receive.svg',
        name: ERouteName.PatientManagement_Payment
      },
      {
        path: PATIENT_MANAGEMENT_PATHS.paymentDetail,
        rootPath: '',
        component: <PaymentPage />,
        icon: '/images/ic-receive.svg',
        name: ERouteName.PatientManagement_PaymentDetail
      }
    ]
  },
  {
    path: PATIENT_MANAGEMENT_PATHS.prescription,
    rootPath: PATIENT_MANAGEMENT_PATHS.main,
    component: <PrescriptionPage />,
    icon: '/images/ic-document.svg',
    name: ERouteName.PatientManagement_Prescription
  },
  {
    path: PATIENT_MANAGEMENT_PATHS.transaction,
    rootPath: PATIENT_MANAGEMENT_PATHS.main,
    component: <TransactionPage />,
    icon: '/images/ic-document.svg',
    name: ERouteName.PatientManagement_Transaction
  }
]

export const ROUTES_MENU_MANAGEMENT: Array<IRoute> = [
  {
    path: MENUS_MANAGEMENT_PATHS.groupService,
    rootPath: MENUS_MANAGEMENT_PATHS.main,
    component: <GroupServicePage />,
    icon: '/images/ic-group-service.svg',
    name: ERouteName.MenuManagement_GroupService
  },
  {
    path: MENUS_MANAGEMENT_PATHS.subService,
    rootPath: MENUS_MANAGEMENT_PATHS.main,
    component: <SubServicePage />,
    icon: '/images/ic-dollar.svg',
    name: ERouteName.MenuManagement_SubService
  },
  {
    path: MENUS_MANAGEMENT_PATHS.workingSchedule,
    rootPath: MENUS_MANAGEMENT_PATHS.main,
    component: <WorkingSchedulePage />,
    icon: '/images/ic-time-setting.svg',
    name: ERouteName.MenuManagement_TimeSetting
  },
  {
    path: MENUS_MANAGEMENT_PATHS.doctor,
    rootPath: MENUS_MANAGEMENT_PATHS.main,
    component: <DoctorPage />,
    icon: '/images/ic-doctor.svg',
    name: ERouteName.MenuManagement_Doctor
  },
  {
    path: MENUS_MANAGEMENT_PATHS.clinicRoom,
    rootPath: MENUS_MANAGEMENT_PATHS.main,
    component: <ClinicRoomPage />,
    icon: '/images/ic-clinic-setting.svg',
    name: ERouteName.MenuManagement_ClinicRoomSetting
  },
  {
    path: MENUS_MANAGEMENT_PATHS.template,
    rootPath: MENUS_MANAGEMENT_PATHS.main,
    component: <TemplatePage />,
    icon: '/images/ic-template.svg',
    name: ERouteName.MenuManagement_Template
  }
]

export const ROUTES_EXAM: Array<IRoute> = [
  {
    path: EXAM_MANAGEMENT_PATHS.exam,
    rootPath: EXAM_MANAGEMENT_PATHS.main,
    icon: '/images/ic-exam.svg',
    name: ERouteName.ExamGroup_Exam,
    children: [
      {
        path: '/',
        rootPath: '',
        component: <ExamPage />,
        icon: '/images/ic-receive.svg',
        name: ERouteName.ExamGroup_Exam
      },
      {
        path: '/:id',
        rootPath: '',
        component: <ExamPage />,
        icon: '/images/ic-receive.svg',
        name: ERouteName.ExamGroup_Exam_Patient
      }
    ]
  },
  {
    path: EXAM_MANAGEMENT_PATHS.patient,
    rootPath: EXAM_MANAGEMENT_PATHS.main,
    icon: '/images/ic-doctor.svg',
    name: ERouteName.PatientManagement_Patient,
    hideOnMainPage: true,
    children: [
      {
        path: '/',
        rootPath: '',
        component: <BookingPage tab={TabTypeBooking.Patient} />,
        icon: '/images/ic-booking.svg',
        name: ERouteName.PatientManagement_Booking
      },
      {
        path: EXAM_MANAGEMENT_PATHS.patientDetail,
        rootPath: '',
        component: <PatientDetailPage />,
        icon: '/images/ic-booking.svg',
        name: ERouteName.PatientManagement_PatientDetail
      },
      {
        path: '/',
        rootPath: '',
        component: <BookingPage tab={TabTypeBooking.Patient} />,
        icon: '/images/ic-booking.svg',
        name: ERouteName.PatientManagement_Patient
      }
    ]
  },
  {
    path: EXAM_MANAGEMENT_PATHS.supersonic,
    rootPath: EXAM_MANAGEMENT_PATHS.main,
    component: <SupersonicPage />,
    icon: '/images/ic-supersonic.svg',
    name: ERouteName.ExamGroup_Supersonic
  },
  {
    path: EXAM_MANAGEMENT_PATHS.subclinical,
    rootPath: EXAM_MANAGEMENT_PATHS.main,
    component: <SubclinicalPage />,
    icon: '/images/ic-subclinical.svg',
    name: ERouteName.ExamGroup_Subclinical
  }
]

export const ROUTES_REPO_MANAGEMENT: Array<IRoute> = [
  {
    path: REPO_MANAGEMENT_PATHS.inventory,
    rootPath: REPO_MANAGEMENT_PATHS.main,
    component: <RepoInventoryPage />,
    icon: '/images/ic-inventory.svg',
    name: ERouteName.RepoManagement_Inventory
  },
  {
    path: REPO_MANAGEMENT_PATHS.import,
    rootPath: REPO_MANAGEMENT_PATHS.main,
    component: <RepoImportPage />,
    icon: '/images/ic-warehouse.svg',
    name: ERouteName.RepoManagement_Import
  },
  {
    path: REPO_MANAGEMENT_PATHS.export,
    rootPath: REPO_MANAGEMENT_PATHS.main,
    component: <RepoExportPage />,
    icon: '/images/ic-export.svg',
    name: ERouteName.RepoManagement_Export
  }
]

export const ROUTES_HELP: Array<IRoute> = [
  {
    path: HELP_PATHS.userManual,
    rootPath: HELP_PATHS.main,
    component: <UserManual />,
    icon: '/images/pg-guide.png',
    name: ERouteName.HelpGroupUserManual
  },
  {
    path: HELP_PATHS.contact,
    rootPath: HELP_PATHS.main,
    component: <Contact />,
    icon: '/images/pg-contact.png',
    name: ERouteName.HelpGroupContact
  }
]

export const ROUTES_GROUP: Array<IRoute> = [
  {
    path: `${ACCOUNT_MANAGEMENT_PATHS.main}/*`,
    children: ROUTES_ACCOUNTS_MANAGEMENT,
    name: ERouteName.AccountManagementGroup,
    color: ERouteGroupColor.Primary
  },
  {
    path: `${MENUS_MANAGEMENT_PATHS.main}/*`,
    children: ROUTES_MENU_MANAGEMENT,
    name: ERouteName.MenuManagementGroup,
    color: ERouteGroupColor.Orange
  },
  {
    path: `${PATIENT_MANAGEMENT_PATHS.main}/*`,
    children: ROUTERS_MANAGEMENT_PATIENT,
    name: ERouteName.PatientManagementGroup,
    color: ERouteGroupColor.Red
  },
  {
    path: `${EXAM_MANAGEMENT_PATHS.main}/*`,
    children: ROUTES_EXAM,
    name: ERouteName.ExamGroup,
    color: ERouteGroupColor.Violet
  },
  {
    path: `${REPO_MANAGEMENT_PATHS.main}/*`,
    children: ROUTES_REPO_MANAGEMENT,
    name: ERouteName.RepoManagementGroup,
    color: ERouteGroupColor.Blue
  },
  {
    path: `${HELP_PATHS.main}/*`,
    children: ROUTES_HELP,
    name: ERouteName.HelpGroup,
    color: ERouteGroupColor.Amber
  }
]
